export default __webpack_public_path__ + "static/media/icon-aircraft-listings.75027072.svg";